import { render, staticRenderFns } from "./AdminSetup.vue?vue&type=template&id=225b3d4e"
import script from "./AdminSetup.vue?vue&type=script&lang=js"
export * from "./AdminSetup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports